module.exports = __webpack_public_path__ + "images/emoji/oncoming_police_car.4a5fbdfeb59936d1f4ef.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/oncoming_police_car.png
// module id = KCSv
// module chunks = 1